import ControlView from "views/control_view";
/* eslint-disable
    consistent-return,
    func-names,
    no-multi-assign,
    no-param-reassign,
    no-shadow,
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let ButtonView;

// Represents a button.
export default ButtonView = (function () {
  ButtonView = class ButtonView extends ControlView {
    static initClass() {
      this.prototype.className = "button";
      this.prototype.tagName = "a";
    }

    initialize(options) {
      if (options == null) { options = {}; }
      ({ action: this.action, label: this.label, title: this.title, icon: this.icon } = options);

      // if title isn't set, default it to label
      if ((this.title == null) && this.label) { this.title = this.label; }
      this.render();
      return super.initialize(options);
    }

    render() {
      this.$el.attr("href", "#");
      if (this.action != null) { this.$el.attr("data-action", this.action); }
      if (this.label != null) { this.$el.html(this.label); }
      if (this.title != null) { this.$el.attr("title", this.title); }
      if (this.icon != null) { return this.$el.prepend(`<i class=\"${this.icon}\"></i> `); }
    }

    setTitle(title) {
      this.title = title;
      this.label = title;
      return this.render();
    }
  };
  ButtonView.initClass();
  return ButtonView;
}());
